export interface PaisDocumento {
  id: number;
  pais_codigo: string;
  tipo_documento_codigo: number;
}

export function createEmptyPaisDocumento(): PaisDocumento {
  return {
    id: null,
    pais_codigo: null,
    tipo_documento_codigo: null
  };
}

export function createPaisDocumento(params: any): PaisDocumento {
  return {
    ...createEmptyPaisDocumento(),
    ...params
  };
}
